import { IVoiceOption } from 'assets/sounds/widgetAudio';
import React from 'react';
import { Panel } from '../Panel';
import { WatchIndex as WIndex } from './WIndex';

interface IWatchIndex {
	symbol: string,
	time: any,
	title: string,
	unit: any,
	voices: IVoiceOption,
	id: number
	handleRemoveWidget: (id: number) => void
}

const updateWidget = () => null

export const WatchIndex: React.FunctionComponent<IWatchIndex> = ({ symbol, time, title, unit, voices, id, handleRemoveWidget }) => {
	return (
		<Panel
			title={title}
			id={id}
			isActive={true}
			handler="watch-handle pt-1 pb-0"
			canPopout={false}
			hideHeader={false}
			canScroll={false}
			handleRemoveWidget={handleRemoveWidget}
			left={0}
			top={0}
			height={0}
			width={0}
			updateLayout={updateWidget}
			zIndex={0}
		>
			<WIndex id={id} title={title} symbol={symbol} voices={voices} />
		</Panel>
	);
}

export default WatchIndex;
